import styled, { css } from 'styled-components';

export const BlueStrong = styled.span`
  ${({ theme }) => css`
    color: ${theme.color.support.blue.strong};
    font-weight: inherit;
  `}
`;

export const ValueText = styled.span`
  text-decoration: line-through;
  font-weight: inherit;
`;

export const StrongText = styled.span`
  ${({ theme }) => css`
    font-weight: ${theme.font.weight.bold};
  `}
`;

export const UnderlinedText = styled.span`
  ${({ theme }) => css`
    cursor: pointer;
    text-decoration: underline;
    font-weight: ${theme.font.weight.bold};
  `}
`;
